/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react'
import {Button, InputLabel, Modal} from '@scuf/common';
import {injectIntl} from 'react-intl';
import connect from "react-redux/es/connect/connect";

class AboutWindow extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        }

        this.closeModal = this.closeModal.bind(this)
        this.openModal = this.openModal.bind(this)

    }

    closeModal() {
        this.setState({modalOpen: false})
    }

    openModal() {
        this.setState({modalOpen: true})
    }

    render() {
        const {build, intl} = this.props
        const hda = build.isHdaEnvironment === 'true' ? '-hda' : ''

        return (
            <span className="clickable" >
                <Modal
                    size="small"
                    closeIcon={true}
                    open={this.state.modalOpen}
                    onClose={this.closeModal}
                    closeOnDimmerClick={true}
                    closeOnDocumentClick={true}
                >
                    <Modal.Header>
                        <div id="login-logo">
                        <div id={"hon-logo" + hda}></div>
                        <div id="logo-title"><span>{build.name}</span></div>
                    </div>
                    </Modal.Header>
                    <Modal.Content>
                        <InputLabel
                            label={intl.formatMessage({id: "about.version"}) + ": " + build.version}
                        />

                    </Modal.Content>
                    <Modal.Footer>
                         <Button
                             id="about-ok"
                             type="primary"
                             content={intl.formatMessage({id: "about.ok"})}
                             onClick={this.closeModal}/>
                    </Modal.Footer>
                </Modal>

                <span className="about-window-trigger" onClick={this.openModal}>
                    {intl.formatMessage({id: "about.menu"})}
                </span>
            </span>
        )
    }
}

const mapStateToProps= state => {
    return {
        build: state.version.build,
    };
};

export default injectIntl(connect(mapStateToProps)(AboutWindow))